import { colorsMap } from "./colors"

export const theme = {
  colors: colorsMap,
  space: {
    0: "0px",
    2: "2px",
    4: "4px",
    6: "6px",
    8: "8px",
    12: "12px",
    16: "16px",
    20: "20px",
    24: "24px",
    32: "32px",
    40: "40px",
    48: "48px",
    56: "56px",
    64: "64px",
    72: "72px",
    80: "80px",
    88: "88px",
    96: "96px",
    128: "128px",
    192: "192px",
    256: "256px",
  },
  fonts: {
    sans: "Lato, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
  },
  sizes: {
    0: "0px",
    2: "2px",
    4: "4px",
    6: "6px",
    8: "8px",
    12: "12px",
    16: "16px",
    20: "20px",
    24: "24px",
    32: "32px",
    40: "40px",
    48: "48px",
    56: "56px",
    64: "64px",
    72: "72px",
    80: "80px",
    88: "88px",
    96: "96px",
    128: "128px",
    192: "192px",
    256: "256px",
  },
  radii: {
    0: "0px",
    2: "2px",
    4: "4px",
    8: "8px",
    16: "16px",
    32: "32px",
    pill: "9999px",
    rounded: "50%",
  },
  zIndices: {
    "-1": -1,
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "10": 10,
    max: 2147483647,
  },
}
